import { createContext } from 'react';
import { SubmitButtonContextType } from '../../types';

export const SubmitButtonContext = createContext<
  Partial<SubmitButtonContextType>
>({});
